/*
 * Module for the DROP Plans Index View
 */
rs.module("content/fund/configuration/dropplans",

    [
        "controls/data/grid",
        "common/visibility",
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (gridModule, visibility, selectHelper, eventBanner) {

        var _executeSelectionChanged;
        var firstDropInterestRateKey;

        // Initialize the page
        function initialize(jsSelectors, urls, processingGridLrsApi, interestDetailsGridLrsApi, isDropPlanDefined) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var dropPlanSection = criteria.js(jsSelectors.dropPlanSection);
            var dropPlanSelect = criteria.js(jsSelectors.dropPlanSelect);
            var addNewPlanButton = criteria.js(jsSelectors.addNewPlanButton);
            var cancelAddNewButton = criteria.js(jsSelectors.cancelAddNewButton);

            var selectedDropPlanKey = criteria.js(jsSelectors.selectedDropPlanKey, { multiple: true });

            var planDetailCard = criteria.js(jsSelectors.planDetailCard);
            var dropPlanUpdateToken = criteria.js(jsSelectors.dropPlanUpdateToken);
            var dropPlanNameInput = criteria.js(jsSelectors.dropPlanNameInput);
            var effectiveDateInput = criteria.js(jsSelectors.effectiveDateInput);
            var terminationDateInput = criteria.js(jsSelectors.terminationDateInput);

            var participationDetailCard = criteria.js(jsSelectors.participationDetailCard);
            var participationDetailAddLink = criteria.js(jsSelectors.participationDetailAddLink);

            var interestRatesCard = criteria.js(jsSelectors.interestRatesCard);
            var interestRatesDetailAddLink = criteria.js(jsSelectors.interestRatesDetailAddLink);
            var interestRatesDetailSaveButton = criteria.js(jsSelectors.interestRatesDetailSaveButton);
            var interestRatesDetailCancelButton = criteria.js(jsSelectors.interestRatesDetailCancelButton);

            var interestRateDetailForm = criteria.js(jsSelectors.interestRateDetailForm);
            var interestRateDetailUpdateToken = criteria.js(jsSelectors.interestRateDetailUpdateToken);
            var interestRateKey = criteria.js(jsSelectors.dropInterestRateKey);
            var interestRateRateInput = criteria.js(jsSelectors.interestRateRateInput);
            var interestRateEffectiveDate = criteria.js(jsSelectors.interestRateEffectiveDate);
            var hiddenInterestRateEffectiveDate = criteria.js(jsSelectors.hiddenInterestRateEffectiveDate);
            var interestRateTerminationDate = criteria.js(jsSelectors.interestRateTerminationDate);
            var interestRateFrequencySelect = criteria.js(jsSelectors.interestRateFrequencySelect);
            var interestRateDenominatorInput = criteria.js(jsSelectors.interestRateDenominatorInput);

            // Build select list helper(s)
            var interestRateFrequencySelectHelper = selectHelper.getHelper(interestRateFrequencySelect);

            // Set up form js triggers
            dropPlanSelect.change(dropPlanSelected);
            addNewPlanButton.click(setupAddNewDropPlan);
            cancelAddNewButton.click(undoAddNewDropPlan);

            // Perform on-load actions
            if (!isDropPlanDefined) {
                effectiveDateInput.val('');
            }

            if (interestDetailsGridLrsApi.selectedValues.length != 0) {
                firstDropInterestRateKey = interestDetailsGridLrsApi.selectedValues[0];
            }
            else {
                visibility.hide(interestRateDetailForm);
            }

            // Setup page for adding a new DROP Plan
            function setupAddNewDropPlan() {

                // hide all
                visibility.hide(addNewPlanButton);
                visibility.hide(participationDetailCard);
                visibility.hide(interestRatesCard);
                visibility.hide(dropPlanSection);
                visibility.show(cancelAddNewButton);

                // Clear event banner
                eventBanner.removeAllMessages();

                // Set new DROP Plan Key
                selectedDropPlanKey.val(-1);

                // Clear and show Plan Detail Card
                clearPlanDetailCard();
                visibility.show(planDetailCard);
            }

            // Setup the page for editing an existing plan.
            function undoAddNewDropPlan() {

                visibility.show(addNewPlanButton);
                selectedDropPlanKey.val(dropPlanSelect.val());

                if (dropPlanSelect.val()) {
                    dropPlanSelected();

                    visibility.show(participationDetailCard);
                    visibility.show(interestRatesCard);
                    visibility.show(dropPlanSection);
                    visibility.hide(cancelAddNewButton);
                }
                else {
                    visibility.hide(planDetailCard);
                    visibility.hide(cancelAddNewButton);
                    visibility.show(dropPlanSection);
                }


            }

            // Repopulate page for newly selected drop plan
            function dropPlanSelected() {

                clearPlanDetailCard();
                selectedDropPlanKey.val(dropPlanSelect.val());
                eventBanner.removeAllMessages();
                visibility.show(addNewPlanButton);
                visibility.hide(interestRateDetailForm);

                if (dropPlanSelect.val() == '') {

                    // Hide All
                    visibility.hide(planDetailCard);
                    visibility.hide(participationDetailCard);
                    visibility.hide(interestRatesCard);
                }
                else {

                    loadPlanDetailCard();
                    loadParticipationDetailCard();
                    loadInterestRatesCard();
                }
            }


            // Loads the Plan Detail Card
            function loadPlanDetailCard() {
                $.getJSON(urls.getPlanDetail, { dropPlanKey: dropPlanSelect.val() }).done(function (data) {

                    dropPlanUpdateToken.val(data.updateToken);
                    dropPlanNameInput.val(data.planName);
                    effectiveDateInput.val(data.effectiveDate);
                    terminationDateInput.val(data.terminationDate);

                    // Set the add links for the cards to match
                    participationDetailAddLink.attr('href', data.participationDetailAddLink);

                    visibility.show(planDetailCard);
                });
            }

            // Loads the Plan Participation Detail Card
            function loadParticipationDetailCard() {
                gridModule.update(

                    urls.getPlanParticipationDetails,
                    { dropPlanKey: dropPlanSelect.val() },

                    processingGridLrsApi.agGridApi,

                    function done(gridUpdate) {
                        visibility.show(participationDetailCard);
                    }
                );
            }

            // Loads Interest Rates Card
            function loadInterestRatesCard() {
                gridModule.update(

                    urls.getInterestRateDetails,
                    { dropPlanKey: dropPlanSelect.val() },

                    interestDetailsGridLrsApi.agGridApi,

                    function done(gridUpdate) {
                        interestDetailsGridLrsApi.selectFirstRow();

                        if (interestDetailsGridLrsApi.selectedValues.length != 0) {
                            firstDropInterestRateKey = interestDetailsGridLrsApi.selectedValues[0];
                        }
                        else {
                            visibility.hide(interestRateDetailForm);
                        }

                        visibility.show(interestRatesCard);
                    }
                );
            }

            // Handle the interest rate detail add button click
            interestRatesDetailAddLink.click(function () {
                clearInterestRatesForm();
                eventBanner.removeAllMessages();
                interestDetailsGridLrsApi.selectedValues = null;
                interestRateKey.val(-1);

                $.getJSON(urls.getInterestRateEffectiveDate, { dropPlanKey: dropPlanSelect.val() }).done(function (data) {

                    if (data.isPredetermined) {
                        interestRateEffectiveDate.val(data.nextEffectiveDate).prop('disabled', true).clearErrors();
                        hiddenInterestRateEffectiveDate.val(data.nextEffectiveDate);
                    }
                    else {
                        interestRateEffectiveDate.val('').prop('disabled', false).clearErrors();
                    }
                });

                disableInterestRatesForm(false);
                visibility.show(interestRateDetailForm);
            });

            // Handle the interest rate detail cancel button click
            interestRatesDetailCancelButton.click(function () {

                // Canceling should revert to the first record in the grid.
                interestDetailsGridLrsApi.selectedValues = null;
                interestDetailsGridLrsApi.selectFirstRow();

                // If no rows exist, hide form view
                if (interestDetailsGridLrsApi.selectedValues.length == 0) {
                    visibility.hide(interestRateDetailForm);
                }
            });

            interestDetailsGridLrsApi.selectionChanged(function (values, rows) {
                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    var dropInterestRateKey = values[0];
                    interestRateKey.val(dropInterestRateKey);

                    // Remove event banner messages
                    eventBanner.removeAllMessages();

                    // Disable if not the most recently effective
                    disableInterestRatesForm(dropInterestRateKey != firstDropInterestRateKey);

                    $.getJSON(urls.getInterestRatesForm, { dropInterestRateKey: dropInterestRateKey }).done(function (data) {

                        interestRateRateInput.val(data.rate);
                        interestRateDetailUpdateToken.val(data.updateToken);
                        interestRateEffectiveDate.val(data.effectiveDate).clearErrors();
                        interestRateTerminationDate.val(data.terminationDate).clearErrors();
                        interestRateFrequencySelectHelper.setValue(data.frequency);
                        interestRateFrequencySelect.clearErrors();
                        interestRateDenominatorInput.val(data.denominator).clearErrors();

                        visibility.show(interestRateDetailForm);
                    });

                }

                _executeSelectionChanged = true;
            });

            // Clears the Plan Detail Card's inputs
            function clearPlanDetailCard() {
                [
                    dropPlanNameInput,
                    effectiveDateInput,
                    terminationDateInput
                ].forEach((input) => input.clearErrors().val(''));
            }

            // Enable and disable the fields in the Interest Rates Form
            function disableInterestRatesForm(disable) {
                [
                    interestRateRateInput,
                    interestRateEffectiveDate,
                    interestRateTerminationDate,
                    interestRateDenominatorInput
                ].forEach((input) => input.prop('disabled', disable).clearErrors());

                interestRateFrequencySelectHelper.setDisabled(disable);
                interestRateFrequencySelect.clearErrors();

                if (disable) {
                    visibility.hide(interestRatesDetailSaveButton);
                    visibility.hide(interestRatesDetailCancelButton);
                }
                else {
                    visibility.show(interestRatesDetailSaveButton);
                    visibility.show(interestRatesDetailCancelButton);
                }
            }

            // Clears the Interest Rates Form
            function clearInterestRatesForm() {
                [
                    interestRateRateInput,
                    interestRateTerminationDate,
                    interestRateDenominatorInput
                ].forEach((input) => input.clearErrors().val(''));

                interestRateFrequencySelectHelper.selectIndex(0);
                interestRateFrequencySelect.clearErrors();
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);